import { routeSlice } from './route-slice';

export const { setCurrentRoutePath } = routeSlice.actions;
export default routeSlice;
